<template>
  <b-navbar id="nav-bar" toggleable="md" class="no-gutters">
    <div class="container-fluid">
      <!-- Search bar and logo-->
      <b-row class="mt-2">
        <!-- Company logo -->
        <b-col sm="12" md="4" class="text-left pr-0 my-1">
          <router-link to="/">
            <img src="../../searchLogo.png" class="company-logo" />
          </router-link>
          <b-nav-toggle target="navbar-collapse" class="mx-2" id="toggle-navbar-btn" style></b-nav-toggle>
        </b-col>
        <b-col cols="12" sm="12" md="8" class="pr-0 px-md-4 mt-2 mt-md-0 my-1">
          <form id="search-bar" action="/search" class="input-group mb-3 mr-2">
            <b-input
              id="search-text"
              name="query"
              :value="$route.query.query"
              placeholder="Search For Product"
              type="text"
              size="sm"
              autocomplete="off"
              required
            ></b-input>
            <div class="input-group-append">
              <b-button id="search-btn" size="sm">
                <font-awesome-icon icon="search" :style="{ color: '#999' }"></font-awesome-icon>
              </b-button>
            </div>
          </form>
        </b-col>
      </b-row>

      <!-- Dropdown menus second row of navbar -->
      <b-row class="mb-2 justify-content-center">
        <b-collapse is-nav id="navbar-collapse" style="justify-content:left">
          <b-navbar-nav>
            <!-- About us -->
            <b-nav-item
              class="text-center mr-2"
              v-on:click="
                  $router.push({
                    name: 'About',
                  })
                "
            >
              <font-awesome-icon icon="info"></font-awesome-icon>
              <span>&nbsp;About Us</span>
            </b-nav-item>

            <!-- Occasions -->
            <b-nav-item-dropdown class="text-center mr-2">
              <template slot="button-content">
                <font-awesome-icon icon="calendar-week"></font-awesome-icon>
                <span>&nbsp;Occasions</span>
              </template>
              <b-dropdown-item
                v-for="(occasion, index) in occasions"
                :key="index"
                v-on:click="
                  $router.push({
                    name: 'Occasion',
                    params: { occasion: occasion.url },
                  })
                "
              >{{ occasion.name }}</b-dropdown-item>
            </b-nav-item-dropdown>
            <!-- Themes -->

            <b-nav-item-dropdown class="text-center mr-2">
              <template slot="button-content">
                <font-awesome-icon icon="puzzle-piece"></font-awesome-icon>
                <span>&nbsp;Themes</span>
              </template>
              <b-dropdown-item
                v-for="(theme, index) in themes"
                :key="index"
                v-on:click="
                  $router.push({
                    name: 'Theme',
                    params: { theme: getUrl(theme.name) },
                  })
                "
              >{{ theme.name }}</b-dropdown-item>
            </b-nav-item-dropdown>

            <!-- Balloons -->
            <b-nav-item
              class="text-center mr-2"
              v-on:click="
                  $router.push({
                    name: 'Theme',
                    params: { theme: 'balloons' },
                  })
                "
            >
              <font-awesome-icon icon="calendar-week"></font-awesome-icon>
              <span>&nbsp;Balloons</span>
            </b-nav-item>

            <!-- Wristbands -->
            <b-nav-item
              class="text-center mr-2"
              v-on:click="
                  $router.push({
                    name: 'Theme',
                    params: { theme: 'wristbands' },
                  })
                "
            >
              <font-awesome-icon icon="ring"></font-awesome-icon>
              <span>&nbsp;Wristbands</span>
            </b-nav-item>

            <!-- Contact Us -->
            <b-nav-item class="text-center mr-2" href="http://www.reflectionsuae.com/acrylics">
              <font-awesome-icon icon="paint-brush"></font-awesome-icon>
              <span>&nbsp;Acrylic Fabrication</span>
            </b-nav-item>

            <!-- Contact Us -->
            <b-nav-item
              class="text-center mr-2"
              v-on:click="
                  $router.push({
                    name: 'Contact'
                  })
                "
            >
              <font-awesome-icon icon="phone"></font-awesome-icon>
              <span>&nbsp;Contact Us</span>
            </b-nav-item>

            <!-- Cart -->
            <b-nav-item
              v-if="currentRouteName != 'Cart'"
              class="px-2 text-center mr-2 flyout-container"
            >
              <div style="font-size:24px;">
                <font-awesome-icon @click="handleCartClick" size="1x" icon="cart-plus"></font-awesome-icon>
                <em>{{ itemsInCartCount }}</em>
                <div class="flyout p-2" v-if="flyoutOpen">
                  <div style="text-align:right;">
                    <a href="#" @click="handleCartClick">
                      <font-awesome-icon color="black" size="1x" icon="times" class="close--flyout" ></font-awesome-icon>
                    </a>
                  </div>
                  <ul class="mini-cart">
                    <MiniProductCard
                      v-for="item in cartItems"
                      :key="item.id"
                      :prod="item"
                      v-on:close-flyout="flyoutOpen = false"
                      v-on:mini-cart-remove="handleMiniCartRemove"
                    />
                  </ul>
                  <hr class="mx-3" style="border-top: 1px solid black" />
                  <div class="mx-3">
                    <span style="float:left" class="pt-0">
                      <small>Inquiry Subtotal : AED&nbsp;{{ orderSubTotal }}</small>
                    </span>
                    <b-button
                      class="btn-primary mini-cart-btn"
                      size="md"
                      style="float:right"
                      v-on:click="$router.push({ name: 'Cart' })"
                    >Place Inquiry</b-button>
                  </div>
                </div>
              </div>
              <label>Inquiry</label>
            </b-nav-item>

            <!-- End of navbar items -->
          </b-navbar-nav>
        </b-collapse>
      </b-row>
    </div>
  </b-navbar>
</template>

<script>
import MiniProductCard from "./cart-components/MiniCartProduct";
import { mapGetters } from "vuex";

export default {
  name: "Navbar",
  components: {
    MiniProductCard,
  },
  computed: {
    ...mapGetters({
      itemsInCartCount: "getCartItemsCount",
      cartItems: "getCartItems",
      orderSubTotal: "getOrderSubTotal",
    }),
    currentRouteName() {
      return this.$route.name;
    },
  },
  data() {
    return {
      flyoutOpen: false,
      occasions: {},
      themes: {},
    };
  },
  methods: {
    handleCartClick() {
      if (this.itemsInCartCount <= 0) {
        this.$router.push({ name: "Cart" });
        return;
      }
      if (window.screen.width <= 768) {
        this.$router.push({ name: "Cart" });
        return;
      } else {
        this.flyoutOpen = !this.flyoutOpen;
      }
    },
    handleMiniCartRemove() {
      if (this.itemsInCartCount <= 0) {
        this.flyoutOpen = false;
        return;
      }
    },
    getOccasions: function () {
      this.$axios.get("occasions").then((res) => {
        if (res.data) {
          this.occasions = res.data.occasions;
        }
      });
    },
    getThemes: function () {
      this.$axios.get("themes").then((res) => {
        if (res.data) {
          this.themes = res.data.themes;
        }
      });
    },
  },
  mounted() {
    this.getOccasions();
    this.getThemes();
  },
};
</script>

<style scope>
#nav-bar svg {
  margin-right: 5px;
}
#nav-bar {
  background-color: #19b3d8;

  margin-right: -15px;
  margin-left: -15px;
  padding-top: 20px;
  padding-bottom: 0;
}
#nav-bar .nav-link {
  color: white;
}
.company-logo {
  width: 285px;
}

@media screen and (max-width: 768px) {
  .company-logo {
    width: 230px;
  }
}

#search-bar {
  border: none;
  background: #c9e4eb;
  border-radius: 10px;
}

#search-bar .input-group-append {
  position: absolute;
  right: 0;
  height: 34px;
}
#search-btn {
  background-color: #c9e4eb;
  border: none;
  border-radius: 10px;
  padding-right: 25px;
  padding-left: 25px;
  z-index: 3;
}
#search-text {
  background-color: #99d5e4;
  border: none;
  border-radius: 10px;
  height: 34px;
  padding-left: 25px;
}

#search-text::placeholder {
  color: #81a1a9;
}
#toggle-navbar-btn {
  background: transparent !important;
  padding: 0;
}
#toggle-navbar-btn,
.dropdown-button,
.dropdown-txt {
  border-color: transparent;
}

#toggle-navbar-btn {
  background-color: white;
  float: right;
}

.cart-count-col {
  padding: 0;
  cursor: default;
}

.flyout {
  position: absolute;
  border: 1px solid #e6e6e6;
  background-color: #ffffff;
  cursor: default;
  color: #000000;
  border-radius: 10px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.4), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  z-index: 1;
  top: 10rem;
  right: 4rem;
  width: 460px;
  max-width: 25%;
  overflow-x: hidden;
}

.flyout .close--flyout path{
  color:black !important;
}
.flyout-container {
  margin-left: auto;
}
.flyout-container a {
  padding: 0;
}
.flyout-container label {
  font-weight: lighter;
  text-transform: uppercase;
  margin-bottom: 0;
}
.mini-cart-btn {
  border-radius: 0.7rem;
  border: 1px solid #03b4db;
  background-color: #03b4db;
  font-weight: 100;
}

.mini-cart-btn:hover {
  border: 1px solid #03b4db;
  background-color: white;
  color: #03b4db;
}

.navbar-expand-md > .container,
.navbar-expand-md > .container-fluid,
.navbar-expand-md > .container-lg,
.navbar-expand-md > .container-md,
.navbar-expand-md > .container-sm,
.navbar-expand-md > .container-xl {
  flex-wrap: wrap;
}

.navbar .container-fluid .row {
  width: 100%;
}
.navbar .navbar-nav {
  width: 100%;
  margin-left: 80px;
}
@media screen and (max-width: 768px) {
  .navbar .navbar-nav {
    margin-left: 0 !important;
  }
}
#navbar-collapse li {
  margin-top: auto;
}
</style>

<style scoped>
path,
em {
  color: white;
  font-weight: 500;
  margin: 0px 3px;
}

ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
.mini-cart {
  max-height: 50vh;
  overflow-y: auto;
  overflow-x:hidden;
}
</style>
